import React from 'react';
import style from './accountLink.module.scss';
import { AccountLink as AccountLinkModel } from 'acscp/api/models/accountLink';
import { PresentationComponentBase } from '../presentationComponentBase';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import { DeleteAccountLinkConfirmationDialog } from './deleteAccountLinkConfirmationDialog';

interface AccountLinkOwnProps {
    accountLink: AccountLinkModel;
    deleteAccountLink: () => void;
}

interface AccountLinkState {
    isDeleteAccountLinkConfirmationOpen: boolean;
}

export class AccountLinkPresentational extends PresentationComponentBase<
    AccountLinkOwnProps, {}, {}, AccountLinkState> {

    constructor(props: AccountLinkOwnProps) {
        super(props);

        this.state = {
            isDeleteAccountLinkConfirmationOpen: false
        };
    }

    closeDeleteConfirmationDialog = () => {
        this.setState({isDeleteAccountLinkConfirmationOpen: false});
    }

    render(): JSX.Element {
        const {accountLink, deleteAccountLink} = this.props;
        return(
            <div className={style.SmallItem}>
                <span className={style.SingleLineInfo}>
                    {accountLink.emailAddress}
                </span>
                <CrossIcon
                    className={style.RemoveItem}
                    onClick={() => this.setState({isDeleteAccountLinkConfirmationOpen: true})}
                />
                <DeleteAccountLinkConfirmationDialog
                    isOpen={this.state.isDeleteAccountLinkConfirmationOpen}
                    closeDialog={this.closeDeleteConfirmationDialog}
                    deleteAccountLink={deleteAccountLink}
                />
            </div>
        );
    }
}

export const AccountLink = AccountLinkPresentational;
